import * as C from '../constants';
import * as THREE from 'three';
import { useSelector, useDispatch } from 'react-redux';

export const useColor = (materials) => {
  const colorsData = useSelector((state: any) => state.app[C.SET_COLORS]);
  const paint = useSelector((state: any) => state.app[C.SET_PAINT]);
  const appData = useSelector((state: any) => state.app[C.APP_DATA]);
  const allPaints = appData?.paint;

  if (colorsData && paint && allPaints) {
    const PAINTS = allPaints.map((paint) => {
      return paint.colors.map((paintColor) => paintColor.colorid);
    });

    Object.keys(PAINTS).forEach((key) => {
      PAINTS[key].forEach((itemName) => {
        const material = materials?.[itemName];
        if (material) {
          material.visible = false;
        }
      });
    });

    const currentPaintId = paint.id;
    PAINTS[currentPaintId - 1].forEach((itemName, index) => {
      const material = materials?.[itemName];
      if (material) {
        const rawColor = colorsData?.[index]?.default || 'white';
        const color = new THREE.Color(rawColor);

        material.visible = true;
        material.color = color;
        material.metalness = 0.5;
        material.roughness = 0.2;
        material.envMapIntensity = 0.2;
      }
    });

    const gatesMaterial = materials?.gates_base;
    if (gatesMaterial && paint.id !== 4) {
      const rawColor = colorsData?.[0]?.default || 'white';
      const color = new THREE.Color(rawColor);

      gatesMaterial.visible = true;
      gatesMaterial.color = color;
      gatesMaterial.metalness = 0.5;
      gatesMaterial.roughness = 0.2;
    } else {
      gatesMaterial.visible = false;
    }
  }

  if (materials) {
    const glass = materials['cockpit_glass'];
    glass.metalness = 1;
    glass.roughness = 0.095;
    // glass.envMap = colorMap;
    glass.envMapIntensity = 0.5;
    // glass.ior = 1.45;
    // glass.transparent = false;
    // glass.alpha = 0.203;
    glass.clearcoat = 0.1;
    // glass.transmission = 1.0;
    // glass.side = THREE.FrontSide;

    // const lightsGlass = materials['light_glass'];
    // lightsGlass.transparent = true;
    // lightsGlass.opacity = 0.3;

    // // TODO FIX seats color
    // const seats = materials['seats_black'];
    // seats.color = {
    //   b: 0,
    //   g: 0,
    //   isColor: true,
    //   r: 0,
    // };
  }

  return null;
};
